import { autoserialize, autoserializeAs } from 'cerialize';

export class StandardDonationReport implements IStandardDonationReport {
  @autoserialize description?: string;
  @autoserializeAs('reported_at') reportedAt?: string;
  @autoserialize photos?: string[];
  @autoserializeAs('user_name') userName?: string;
  @autoserializeAs('vehicle_name') vehicleName?: string;

  constructor(payload?: IStandardDonationReport) {
    this.description = payload?.description;
    this.reportedAt = payload?.reportedAt;
    this.photos = payload?.photos;
    this.userName = payload?.userName;
    this.vehicleName = payload?.vehicleName;
  }
}

export interface IStandardDonationReport {
  description?: string;
  reportedAt?: string;
  photos?: string[];
  userName?: string;
  vehicleName?: string;
}
